import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { rests } from '@core/util/rests';
import { Observable } from 'rxjs';
import { BaseUserResponse, NewUser, ProfileUser } from '@models/user';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpClient) {}

  editProfile(data: ProfileUser): Observable<NewUser> {
    const httpParams = new HttpParams().set('user', JSON.stringify(data));
    return this.http.post<NewUser>(rests.profile.edit, httpParams);
  }

  getProfile(): Observable<BaseUserResponse> {
    return this.http.get<BaseUserResponse>(rests.profile.get);
  }

  changePassword(oldPass: any, newPass: any): Observable<any> {
    const body = {
      verifyPassword: oldPass,
      newPassword: newPass,
    };
    return this.http.put<any>(rests.profile.change_password, body);
  }

  sendCode(phoneNumber: string): Observable<any> {
    return this.http.post(rests.profile.send_code('SIGN_REGULATIONS'), { phoneNumber });
  }

  confirmCode(smsCode: string): Observable<any> {
    return this.http.put(rests.profile.regulations_accept(smsCode), {});
  }
}
